/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rod_Stroke_Learning_In_ProgressInputs */



/**
* | output |
* | --- |
* | "Rod stroke learning in progress" |
*
* @param {Rod_Stroke_Learning_In_ProgressInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rod_stroke_learning_in_progress = /** @type {((inputs?: Rod_Stroke_Learning_In_ProgressInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rod_Stroke_Learning_In_ProgressInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Rod stroke learning in progress")
	return /** @type {LocalizedString} */ ("Apprentissage de la course de tige en cours")
});